(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/components/use-deposit-limits.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/components/use-deposit-limits.js');
"use strict";

const {
  useState,
  useEffect,
  useRef
} = React;
const useDepositLimits = () => {
  const DEPOSITS_SUSPENDED = 'DEPOSITS_SUSPENDED';
  const [fetching, setFetching] = useState(true);
  const [hasDepositLimits, setHasDepositLimits] = useState(false);
  const mountedRef = useRef(true);
  useEffect(() => {
    const getDepositLimits = async () => {
      svs.ui.loader.show();
      try {
        svs.ticketsValidate.logger.debug('fetching currentStatus for player..');
        const {
          response = {}
        } = await svs.core.jupiter.callAsync({
          method: 'GET',
          path: '/player/3/info?include=accountBalance,currentStatus'
        });
        svs.ticketsValidate.logger.debug('..fetched currentStatus for player');
        if (mountedRef.current) {
          var _response$currentStat;
          setHasDepositLimits((_response$currentStat = response.currentStatus) === null || _response$currentStat === void 0 ? void 0 : _response$currentStat.includes(DEPOSITS_SUSPENDED));
        }
      } catch (e) {
        svs.ticketsValidate.logger.warn('..failed to fetch currentStatus for player..', e);
      }
      setFetching(false);
      svs.ui.loader.hide();
    };
    getDepositLimits();
    return () => {
      mountedRef.current = false;
    };
  }, []);
  return {
    fetchingDepositLimits: fetching,
    hasDepositLimits
  };
};
setGlobal('svs.ticketsValidate.pages.validated.useDepositLimits', useDepositLimits);

 })(window);